import * as React from "react";
import { CheckCircle, CloseOutlined } from "@mui/icons-material";
import { Box, Container, Stack } from "@mui/material";
import { BasicDropzone } from "../molecules/BasicDropzone";
import { UploadedDocument } from "@/types";

export type SimpleUploadFieldProps = {
  busy: boolean;
  entries: ReadonlyArray<UploadedDocument>;
  error?: string;
  upload: (fs: File[]) => void;
  remove: (id: string) => void;
  setError: (message: string) => void;
  tag?: string;
};

export const SimpleUploadField: React.FC<SimpleUploadFieldProps> = ({
  busy,
  entries,
  error,
  upload,
  remove,
  setError,
}) => {
  return (
    <Stack rowGap={2}>
      <BasicDropzone
        files={undefined}
        errors={!error ? undefined : ([error] as readonly string[])}
        onDrop={upload}
        isUploading={busy}
        multiple={true}
        setError={setError}
      />

      <Container>
        <Stack>
          {entries.map(({ id, filename }) => (
            <Stack key={id} direction="row" alignItems="start" columnGap={1}>
              <span style={{ verticalAlign: "sub" }}>
                <CheckCircle fontSize="small" color="success" />
              </span>
              <Box>{filename}</Box>
              <a
                href="#"
                style={{ color: "#b00000", cursor: "pointer", textDecoration: "none" }}
                onClick={(ev) => {
                  ev.preventDefault();
                  remove(id);
                }}
              >
                <span style={{ verticalAlign: "top" }}>remove</span>
                <span style={{ verticalAlign: "sub" }}>
                  <CloseOutlined fontSize="small" />
                </span>
              </a>
            </Stack>
          ))}
        </Stack>
      </Container>
    </Stack>
  );
};
